import type { AllRouteEndpoints } from "../routeTypes";

export const integrationsDirectCdiSegmentsConfig = "/integrations/direct/cdi/segments_config";
export const integrationsDirectCdiSegmentsConfigCacheKeys: AllRouteEndpoints[] = [
  integrationsDirectCdiSegmentsConfig,
];
